import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import EvaluatorService from '../../../Services/EvaluatorService';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ReportRunnerService from '../../../Services/ReportRunnerSerivce';
import ErrorMessage from '../../../Elements/ErrorMessage';
import SchedulingExportItem from './SchedulingExportItem';
import EvaluatorPersonaAndSchedulingSearchParams from './EvaluatorPersonaAndSchedulingSearchParams';

class EvaluatorSchedulingExportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    const searchItem = new EvaluatorPersonaAndSchedulingSearchParams();

    this.state = {
      shownPanel: ShownPanelsEnum.Search,
      searchItem,
      orderDirection: 'Asc',
      selected: -1,
      selectedEvaluator: null,
      shownOverWindow: ShownOverWindowsEnum.None,
      tipaltiEvaluator: null,
      evaluatorList: [],
      cleared: process.env.NODE_ENV !== 'development',
    };
    this.startSearch = this.startSearch.bind(this);
    this.handleExportOnClick = this.handleExportOnClick.bind(this);
  }

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  handleExportOnClick() {
    ReportRunnerService.ExportSchedulingReportToExcel(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('ESEA43')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={SchedulingExportItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorService.GetSchedulingExportEvaluators}
          convertDBItemsFunction={EvaluatorService.ConvertDBEvaluator}
          searchParamsType={EvaluatorPersonaAndSchedulingSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='ESEA66'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportOnClick}
          excelExportRoleKey='scheduling_export_button'
        />
      </div>
    );
  }
}

export default EvaluatorSchedulingExportAdmin;
